const utils = require('analytics/utils');
const anaConsts = require('analytics/constants');
const deepExtend = require('utils/deepExtend');

module.exports = function () {
    const currentEvent = utils.getMostRecentEvent(anaConsts.LINK_TRACKING_EVENT);
    const newProductString = (currentEvent.eventInfo.attributes.productStrings += '|eVar72=' + anaConsts.PAGE_TYPES.USER_PROFILE);
    const internalCampaign = anaConsts.CAMPAIGN_STRINGS.ADD_FLASH_TO_BASKET;

    deepExtend(currentEvent, {
        eventInfo: {
            attributes: {
                productStrings: newProductString,
                actionInfo: internalCampaign,
                internalCampaign: internalCampaign
            }
        }
    });
};
